<template>
	<div>
		<div class="header" style="padding-bottom: 15px">
			<div class="header_actions">
				<div class="header_actions-container">
					<el-alert :title="$t('wanna-save')" type="warning" :closable="false" show-icon />
				</div>
			</div>
		</div>

		<div style="display: flex; width: 100%; overflow-y: hidden">
			<!-- Custom fields -->
			<div style="display: flex; flex-direction: column; height: 72vh; overflow-x: scroll">
				<div v-if="questions.filter(x => isItAnObjectQuestionMark(x.question.value)).length > 0">
					<div v-for="(s, index) in questions" :key="index" :id="'qst_' + s.id + '-' + s.id">
						<h4 v-if="index === 0">{{ $t("questions") | capitalize }}</h4>

						<div style="border: 1pt solid #ccc; padding: 25px">
							<div
								v-if="isItAnObjectQuestionMark(s.question.value)"
								class=""
								style="font-weight: 900; font-size: 18px; padding: 10px; width: 100%"
							>
								{{ s.question.value.name ? s.question.value.name : s.question.value }}
								<br />
							</div>
							<div class="isaq" v-if="isItAnObjectQuestionMark(s.question.value)">
								<div
									class=""
									:key="s.id + 2"
									v-if="s.question.value !== undefined"
									style="display: flex; width: 100%; flex-wrap: wrap"
								>
									<div class="" style="width: 100%">
										<div class="" v-for="(a, i) in s.question.map" :key="i + '' + s.id">
											<el-radio
												@change="
													setValue({ element: s, val: s.value })
													calculateProgress()
												"
												v-model="s.value"
												:label="a.ref"
												>{{ a.value }}
											</el-radio>
										</div>
									</div>
								</div>
							</div>
							<!-- choice -->
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'choice'"
							></div>
							<!--number-->
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'number'"
							>
								<el-input-number
									v-if="s.question.value.level > 0 && s.question.value.level !== undefined"
									@change="
										setValue({ element: s, val: s.value })
										calculateProgress()
									"
									v-model="s.value"
								></el-input-number>
							</div>
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'image'"
							></div>
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'text'"
							></div>
							<div class="isaq" v-else>ERR</div>
						</div>
					</div>
				</div>
				<div style="width: 100%; margin-top: 20px" v-if="variabili.length !== 0">
					<div style="border: 1pt solid #ccc; padding: 25px">
						<el-row type="flex" align="middle">
							<span>
								{{ $t("go-to-bio-informations") }}
							</span>
							<md-button class="md-icon-button">
								<router-link :to="{ name: 'settings.organizations' }" target="_blank">
									<md-icon>open_in_new</md-icon>
								</router-link>
							</md-button>
						</el-row>
					</div>

					<div
						v-for="(variabile, index) in variabili"
						:key="index"
						:id="`com_${variabile.node.id}-${variabile.rid}`"
					>
						<el-row
							v-if="index === 0 || variabili[index - 1].node.level !== variabile.node.level"
							type="flex"
							align="middle"
						>
							<h4>{{ $t("data") | capitalize }} {{ $t(levelTexts[variabile.node.level].name) }}</h4>
							<el-tooltip :content="$t(levelTexts[variabile.node.level].help)" placement="top">
								<md-icon>help</md-icon>
							</el-tooltip>
						</el-row>

						<variable-input
							ref="variable-input"
							:variable="variabile"
							@setField="setField"
							@focusField="focusField"
							@unfocusField="unfocusField"
							@handleImage="handleImage"
						/>
					</div>
				</div>
			</div>
			<!-- Preview -->
			<div
				style="flex: 1; background-color: #fff; height: 80%; overflow-y: auto; display: flex; width: 70%"
				id="save-permanently-html-preview"
			>
				<flat-renderer
					:key="refreshable"
					v-if="doc && loadNext"
					:dati="doc"
					id="rend"
					:toggleBorders="toggleBorders"
					:logged="logged"
					style="width: 100%"
				/>
				<div v-else v-loading="true"></div>
				<div>
					<fill-sidebar from="anteprima" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { filters } from "@/utils/utils"
import FlatRenderer from "@/modules/flowcharts/flat-renderer"
import VariableInput from "./components/variable-input"
import FillSidebar from "@/modules/documents/fill-sidebar"

export default {
	name: "anteprima",
	mixins: [filters],
	props: {
		doc_id: {
			required: false
		},
		unique: {
			required: false
		},
		toggleBorders: {
			default: false
		},
		logged: {
			default: true
		}
	},
	components: {
		FlatRenderer,
		VariableInput,
		FillSidebar
	},
	data() {
		return {
			selected_doc_id: undefined,
			document: null,
			doc: null,
			docTitle: null,
			local_questions: [],
			variables: [],
			loadNext: false,
			levelTexts: {
				1: { name: "project-tag", help: "project-data-help" },
				2: { name: "procedure-tag", help: "procedure-data-help" },
				3: { name: "document-tag", help: "document-data-help" }
			}
		}
	},
	computed: {
		...mapGetters({
			customFields: "prose/variables",
			user: "user/user",
			sidebar: "documents/sidebar",
			questions: "compilation/questions",
			refreshable: "compilation/refreshable",
			normalizedVariables: "compilation/variables",
			progressPercentage: "compilation/progressPercentage",
			progressColor: "compilation/progressColor"
		}),
		variabili() {
			return this.normalizedVariables
				.filter(({ node: { level } }) => level > 0)
				.sort(
					({ node: nodeA }, { node: nodeB }) =>
						nodeA.level - nodeB.level || new Date(nodeA.created_at) - new Date(nodeB.created_at)
				)
		}
	},
	async mounted() {
		this.selected_doc_id = this.doc_id || this.$route.params.documentId
		await this.getData()
	},
	methods: {
		...mapActions({
			addQuestions: "compilation/addQuestions",
			addVariables: "compilation/addVariables",
			connectQuestionVar: "compilation/connectQuestionVar",
			updateValue: "compilation/updateValue",
			setValue: "compilation/setValue"
		}),
		...mapMutations({
			setPercentage: "compilation/SET_PERCENTAGE",
			REFRESH: "compilation/REFRESH"
		}),

		async getData() {
			const flowchartId = this.selected_doc_id

			if (!this.logged) {
				await axios(`${process.env.VUE_APP_API_URL}/api/flowchart/getSavedPublic/${flowchartId}`)
					.then(async res => {
						this.docTitle = res.data.items.nome
						for (let i = 0; i < res.data.items.dati.length; i++) {
							let tmpNodo = res.data.items.dati[i]

							if (tmpNodo.id === null) {
								tmpNodo.id = i
							}
							if (tmpNodo.value) {
								let tttmp = { id: 0, items: [], name: "" }
								tmpNodo.value.forEach(el78 => {
									let tmppppp = JSON.parse(el78.items)
									if (el78.block_type === "shared_blocks") {
										tmppppp.ref_id = el78.block_id
									}
									tmppppp.name = el78.name
									tmppppp.wiki = el78.wiki
									tttmp.items.push(tmppppp)
								})

								tmpNodo.value = [tttmp]
							} else {
								tmpNodo.value = [{ id: 0, items: [], name: "" }]
							}
							delete res.data.items.dati[i]["Items"]
						}
						this.doc = res.data.items.dati

						this.getAllVar()
						await this.addQuestions(this.local_questions)
						await this.connectQuestionVar()
						this.loadNext = true

						return true
					})
					.catch(err => console.error(err))
			} else {
				await axios(`${process.env.VUE_APP_API_URL}/api/flowchart/getSaved/${flowchartId}`, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
					.then(async res => {
						this.docTitle = res.data.items.nome
						for (let i = 0; i < res.data.items.dati.length; i++) {
							var tmpNodo = res.data.items.dati[i]

							if (tmpNodo.id === null) {
								tmpNodo.id = i
							}
							if (tmpNodo.value) {
								var tttmp = { id: 0, items: [], name: "" }
								tmpNodo.value.forEach(el78 => {
									var tmppppp = JSON.parse(el78.items)
									if (el78.block_type === "shared_blocks") {
										tmppppp.ref_id = el78.block_id
									}
									tmppppp.name = el78.name
									tmppppp.wiki = el78.wiki
									tttmp.items.push(tmppppp)
								})

								tmpNodo.value = [tttmp]
							} else {
								tmpNodo.value = [{ id: 0, items: [], name: "" }]
							}
							delete res.data.items.dati[i]["Items"]
						}
						this.doc = res.data.items.dati

						this.getAllVar()
						await this.normalizeVars()
						await this.addQuestions(this.local_questions)
						await this.connectQuestionVar()
						this.loadNext = true

						return true
					})
					.catch(err => console.error(err))
			}

			this.REFRESH()
		},
		/**
		 * magia, scorre i nodi e caccia fuori le variabili come elementi html da normalizzare (vedi normalizeVars)
		 * */
		getAllVar(itms = this.doc) {
			itms.forEach(n => {
				if (n.question) {
					if (n.question.value) {
						// aggiunge variabili non presenti nel documento ma come domanda
						if (typeof n.question.value === "object") {
							n.question.value.id = n.question.value.index
							this.variables.push(n.question.value)
						}

						this.local_questions.push({
							id: n.id,
							node_id: n.node_id,
							value: "",
							question: n.question
						})
					}
				}
				if (Array.isArray(n.value)) {
					n.value.forEach(n1 => {
						this.getAllVar(n1.items)
					})
				} else {
					if (n.items) {
						n.items.forEach(n1 => {
							this.getAllVar(n1)
						})
					} else {
						if (n.type === "editor") {
							if (n.value)
								if (n.value.docContent) {
									let doc = document.implementation.createHTMLDocument("")
									doc.open()
									doc.write(n.value.docContent)
									doc.close()

									this.variables.push(
										...Array.prototype.slice.call(doc.getElementsByClassName("custom-variable"))
									)
								}
						}
					}
				}
			})
		},
		async normalizeVars() {
			let tmpArr = []
			this.variables.forEach(variable => {
				if (tmpArr.findIndex(x => x.id == variable.id.replace("x_", "")) === -1)
					tmpArr.push({ id: variable.id.replace("x_", ""), rid: variable.id.replace("x_", "") })
			})
			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/customfields/getVariablesInfo",
					{
						document_id: this.selected_doc_id,
						spans: tmpArr
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(async ({ data: { span: spans = [] } }) => {
					if (spans) {
						let tmp = spans.map(span => {
							if (span.node.rules) span.node.rules = JSON.parse(span.node.rules)
							return span
						})
						await this.addVariables(JSON.parse(JSON.stringify(tmp)))
					}
				})
				.catch(err => {
					console.error(err)
				})
		},
		setField(node, valore) {
			if (!node.node_value) {
				node.node_value = {
					custom_field_id: node.node.id,
					value: valore
				}
			} else {
				node.node_value.value = valore
			}

			this.addVariables(this.normalizedVariables)
			this.connectQuestionVar()
			this.$nextTick(() => this.calculateProgress())
		},
		calculateProgress() {
			this.setPercentage(0)

			const fnIsCompiled = value => !!value

			let filled =
				this.$refs["variable-input"].filter(({ value }) => fnIsCompiled(value)).length +
				this.questions.filter(({ value }) => fnIsCompiled(value)).length

			this.setPercentage(Math.round((filled / (this.variabili.length + this.questions.length)) * 100))
		},
		focusField(field) {
			const target = Array.from(document.querySelectorAll(`[id^='x_${field.node.id}']`))
			target.forEach(span => (span.style.backgroundColor = "yellow"))
		},
		unfocusField(field) {
			const target = Array.from(document.querySelectorAll(`[id^='x_${field.node.id}']`))
			target.forEach(span => (span.style.backgroundColor = "transparent"))
		},
		handleImage(customFieldId, imageFile) {
			let variabile = this.normalizedVariables.find(({ node: { id } }) => id === customFieldId)
			if (variabile) variabile.node.custom_field_value.value = imageFile
		},
		isItAnObjectQuestionMark(val) {
			return typeof val !== "object"
		},
		handleSaveCommand(command) {
			this[command]()
		},
		handleExportCommand(command) {
			this[command]()
		},
		insertBlankRow(element, max_allowd_height) {
			element.childNodes.forEach((n, index) => {
				if (n.offsetHeight > max_allowd_height) {
					this.insertBlankRow(n, max_allowd_height)
				} else {
					const VNode1 = document.createElement(
						"div",
						{ style: `height: ${max_allowd_height - n.offsetHeight} ` },
						[]
					)
					Array.from(element.childNodes).splice(index, 0, VNode1)
				}
			})
		}
	}
}
</script>

<style scoped>
.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	right: 0;
	bottom: 0;
	width: 0px;
	background-color: #f3f3f3 !important;
	transition: width 0.5s;
	border-radius: 25px 0 0 25px;
	height: 72.3vh;
	top: 18%;
}
</style>
